import React, { useState } from "react";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { ReactComponent as EditIcon } from "../../../../../../assets/img/svg/Edit2.svg";
import { ReactComponent as Delete } from "../../../../../../assets/img/svg/Delete.svg";
import { ReactComponent as MultiUsers } from "assets/img/svg/totalUsers.svg";

import EditLectureForm from "./EditLectureForm";
import { useHistory } from "react-router-dom";

import {
  checkDuplicateLecture,
  isLecturePassed,
  uuidValidateV4,
} from "../helper";
import moment from "moment";
import { Tooltip } from "@mui/material";
import MsID from "./../../../edpOps/batch-serach/MsID";
import TestSyllabus from "../../testsListView/TestSyllabus";
import DeleteLectureConfirmationDialog from "./DeleteLectureConfirmationDialog";
import { endpoint } from "../../../common/constant";
import { putpost } from "../../../../../../services/utils";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import ViewDocumentModal from "./ViewDocumentModal";
import LectureListItemBreak from "./LectureListItemBreak";
import CustomHolidayRow from "./CustomHolidayRow";
import { getDayShortName } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";
import MissingLectureItem, { MissingLectureContainer } from "./missingLecture";
import WarningPublishedDialog from "../editViewTimetable/WarningPublishedDialog";

export const openFileInNewWindow = (key) => {
  putpost(
    `${endpoint.fetchS3Url.getDownloadUrl}?key=${key}`,
    (data) => {
      if (data.code === 200 && data.data) {
        window.open(data.data.url);
      } else {
        failureToast("Sorry Something went wrong");
      }
    },
    (data) => {
      failureToast("Sorry Something went wrong");
    },
    {},
    "post"
  );
};

export const badge = {
  // width: "1100",
  height: "35px",
  fontSize: "12px",
  paddingLeft: "10px",
  background: "#F5F5F5",
  borderRadius: "8px",
  // display: "flex",
  alignItems: "center",
  // justifyContent: "space-between",
};
export const rowStyle = {
  fontWeight: "400px",
  fontSize: "14px",
  color: "#262626",
};

export const missingLectureStyles = {
  border: "2px dotted grey",
  borderRadius: "8px",
  background: "#F5F5F5",
};

export const RowCell = ({ width, text, children }) => (
  <div style={{ width: `${width}px` }}>{text || children}</div>
);

export const Header = ({
  isEnabledMsTeamsSync,
  showActions = true,
  openMode = "EDIT",
  isCarrierHYB,
}) => {
  let rowClassName =
    openMode === "VIEW"
      ? "timetable-lecture-details-card-row-view"
      : "timetable-lecture-details-card-row";
  return (
    <div
      className={`${
        isEnabledMsTeamsSync || isCarrierHYB
          ? rowClassName
          : "timetable-lecture-details-card-row-without-msteams"
      } ${!showActions ? "no-actions" : ""}`}
      style={{ ...rowStyle, fontWeight: 600 }}
    >
      <div>Date</div>
      <div>Day</div>
      <div>Start time</div>
      <div>End time</div>
      <div>Class type</div>
      <div>Subject</div>
      <div>Lecture</div>
      <div>Class details</div>
      <div>Faculty</div>
      <div>Room</div>
      {isEnabledMsTeamsSync && <div>Link</div>}
      {isCarrierHYB && <div>Link</div>}
      <div>Status</div>
      {showActions && <div>Actions</div>}
      <div>Batch Info</div> {/* single or breakout */}
    </div>
  );
};

export const LectureListItem = ({
  isLabel = false,
  rowData,
  rowIndex,
  rowChangeHandler,
  deleteHandler,
  currentRoom,
  expandedIndex,
  setExpandedIndex,
  showActions = true,
  selectedFaculty,
  lectures,
  ...props
}) => {
  const history = useHistory();

  const isADBatch = props.batchDetails.businessArea.dispValue === "IC006";
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [viewDocumentUrl, setViewDocumentUrl] = useState(false);

  const [isOpenWarningDialog, setOpenWarningDialog] = useState({
    open: false,
    action: "edit",
  });

  const rowClassName =
    props?.openMode === "VIEW"
      ? "timetable-lecture-details-card-row-view"
      : "timetable-lecture-details-card-row";

  const checkLectureDuplicated = (form, rowIndex) => {
    return checkDuplicateLecture(lectures, form, rowIndex);
  };

  const isAutoPopulateLectures = () => {
    //  check for autoPopulateLectures & OPEN MODAL
    const autoPopulateLectures = [];

    const isCurrentLecturePublished =
      rowData?.id && !uuidValidateV4(rowData?.id);

    lectures.forEach((lect) => {
      if (lect?.isAutoPopulateLecture) autoPopulateLectures.push(lect);
    });

    if (autoPopulateLectures.length && isCurrentLecturePublished) return true;
    return false;
  };

  const deleteBreak = () => {
    isAutoPopulateLectures()
      ? setOpenWarningDialog({ open: true, action: "delete" })
      : setIsDeleteDialogOpen(true);
  };

  const openRespectiveModal = () => {
    if (rowData?.classType === "PTM") {
      props.handleOpenPTMModal("PTM", { ...rowData, isEdit: true }, rowIndex);
    } else if (rowData?.classType?.toLowerCase() === "holiday") {
      props.handleOpenPTMModal({ ...rowData, isEdit: true }, rowIndex);
    } else if (
      rowData?.classType?.toLowerCase() === "lecture" &&
      props.batchDetails.academicCareer.dispValue === "ICON"
    ) {
      props.handleOpenLectureModal(
        "Lecture",
        { ...rowData, isEdit: true },
        rowIndex
      );
    } else {
      rowChangeHandler(rowIndex, { ...rowData, isEdit: true });
    }
  };

  const closeEditing = () => {
    setOpenWarningDialog({ open: false, action: "edit" });
    return;
  };

  if (rowData?.isEdit && rowData?.isMissingLecture)
    return (
      <MissingLectureContainer>
        <EditLectureForm
          currentRoom={currentRoom}
          roomDropdown={props?.roomDropdown}
          updateLecture={rowChangeHandler}
          rowIndex={rowIndex}
          rowData={rowData}
          checkLectureDuplicated={checkLectureDuplicated}
          selectedFaculty={selectedFaculty}
          isCarrierHYB={props?.isCarrierHYB}
          isADBatch={isADBatch}
          {...props}
        />
      </MissingLectureContainer>
    );

  if (rowData?.isEdit)
    return (
      <EditLectureForm
        currentRoom={currentRoom}
        roomDropdown={props?.roomDropdown}
        updateLecture={rowChangeHandler}
        rowIndex={rowIndex}
        rowData={rowData}
        checkLectureDuplicated={checkLectureDuplicated}
        selectedFaculty={selectedFaculty}
        isCarrierHYB={props.isCarrierHYB}
        isADBatch={isADBatch}
        {...props}
      />
    );
  if (rowData?.isMissingLecture)
    return (
      <MissingLectureItem
        rowChangeHandler={rowChangeHandler}
        rowIndex={rowIndex}
        row={rowData}
      />
    );

  if (rowData.lectureName && rowData.lectureName.toLowerCase() === "break")
    return (
      <>
        <LectureListItemBreak
          rowIndex={rowIndex}
          rowData={rowData}
          isEnabledMsTeamsSync={props?.isEnabledMsTeamsSync}
          openMode={props?.openMode}
          rowClassName={rowClassName}
          isDeleteDialogOpen={isDeleteDialogOpen}
          setIsDeleteDialogOpen={(isClose) => {
            deleteBreak();
          }}
          deleteHandler={deleteHandler}
        />

        <DeleteLectureConfirmationDialog
          open={isDeleteDialogOpen}
          setOpen={setIsDeleteDialogOpen}
          data={rowData}
          onAgree={() => deleteHandler(rowIndex)}
        />

        <WarningPublishedDialog
          isOpen={isOpenWarningDialog.open}
          setOpenWarningDialog={(param) =>
            setOpenWarningDialog((prev) => ({ ...prev, open: param }))
          }
          rowData={rowData}
          onConfirm={() => {
            isOpenWarningDialog.action === "edit"
              ? openRespectiveModal()
              : setIsDeleteDialogOpen(true);
          }}
          onCancel={closeEditing}
        />
      </>
    );

  if (rowData?.classType?.toLowerCase() === "holiday")
    return (
      <>
        <CustomHolidayRow
          rowIndex={rowIndex}
          rowData={rowData}
          isEnabledMsTeamsSync={props?.isEnabledMsTeamsSync}
          openMode={props?.openMode}
          rowClassName={rowClassName}
          isDeleteDialogOpen={isDeleteDialogOpen}
          setIsDeleteDialogOpen={(isClose) => {
            deleteBreak();
          }}
          deleteHandler={deleteHandler}
          editHandler={() => {
            isAutoPopulateLectures()
              ? setOpenWarningDialog({ open: true, action: "edit_holiday" })
              : props.handleOpenHolidayModal(rowData, rowIndex);
          }}
          handleOpenHolidayModal={props.handleOpenHolidayModal}
        />
        <DeleteLectureConfirmationDialog
          open={isDeleteDialogOpen}
          setOpen={setIsDeleteDialogOpen}
          data={rowData}
          onAgree={() => deleteHandler(rowIndex)}
        />

        <WarningPublishedDialog
          isOpen={isOpenWarningDialog.open}
          setOpenWarningDialog={(param) =>
            setOpenWarningDialog((prev) => ({ ...prev, open: param }))
          }
          rowData={rowData}
          onConfirm={() => {
            isOpenWarningDialog.action === "edit_holiday"
              ? props.handleOpenHolidayModal(rowData, rowIndex)
              : setIsDeleteDialogOpen(true);
          }}
          onCancel={closeEditing}
        />
      </>
    );

  return (
    <>
      <div
        className={`${
          props?.isEnabledMsTeamsSync || props.isCarrierHYB
            ? rowClassName
            : "timetable-lecture-details-card-row-without-msteams"
        } my-2 ${!showActions ? "no-actions" : ""}`}
        style={{
          ...rowStyle,
          fontWeight: isLabel ? "600" : "400",
          color:
            !isADBatch && isLecturePassed(rowData?.lectureStartTime)
              ? "#B0B0B0"
              : "#262626",
        }}
      >
        <div>{moment(rowData?.date)?.format("DD MMM YYYY")}</div>
        <div>{getDayShortName(rowData?.date)}</div>
        <div>{rowData?.startTime}</div>
        <div>{rowData?.endTime}</div>
        <div>{rowData?.classType}</div>
        <div>
          <Tooltip title={rowData?.language || "English"}>
            {rowData?.subject || "-"}
          </Tooltip>
        </div>
        <div>
          <Tooltip title={rowData?.lectureName}>
            <div className="ellipsis-text-container">
              {rowData?.lectureName || "-"}
            </div>
          </Tooltip>
        </div>
        <div>
          {!["PTM", "Orientation"].includes(rowData.timeTableClassType) ? (
            <span
              className="color-primary regular-bold pointer"
              onClick={() =>
                expandedIndex === rowIndex
                  ? setExpandedIndex(-1)
                  : setExpandedIndex(rowIndex)
              }
            >
              {expandedIndex === rowIndex ? `Hide syllabus` : `View syllabus`}
            </span>
          ) : (
            <span
              className={`regular-bold ${
                rowData?.documentS3Key
                  ? "color-primary pointer"
                  : "color-grey-50 cursor-not-allowed"
              }`}
              onClick={
                rowData?.documentS3Key
                  ? () => openFileInNewWindow(rowData.documentS3Key)
                  : () => {}
              }
            >
              Download
            </span>
          )}
        </div>
        <div>
          <Tooltip title={rowData?.facultyName}>
            <div className="ellipsis-text-container">
              {rowData?.facultyName || "-"}
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip title={rowData?.roomName}>
            <div className="ellipsis-text-container">
              {rowData?.roomName || currentRoom?.label}
            </div>
          </Tooltip>
        </div>
        {(props?.isEnabledMsTeamsSync || props.isCarrierHYB) && (
          <div className="ellipsis-text-container">
            {rowData?.msTeamsId && props?.openMode === "VIEW" ? (
              <MsID
                id={rowData?.msTeamsId}
                copyUrl={rowData?.msTeamsMeetingUrl}
              />
            ) : rowData?.msTeam?.label === "Yes" ||
              rowData?.msTeamsMeetingUrl ? (
              "Yes"
            ) : (
              "No"
            )}
          </div>
        )}

        <div>
          <CustomChip
            textColor={
              !isADBatch && isLecturePassed(rowData?.lectureStartTime)
                ? "#262626"
                : "#0B442D"
            }
            bgColor={
              !isADBatch && isLecturePassed(rowData?.lectureStartTime)
                ? "#F5F5F5"
                : rowData?.status === "ACTIVE"
                ? "#BBE2CE"
                : "#CCCCCC"
            }
            text={
              !isADBatch && isLecturePassed(rowData?.lectureStartTime)
                ? "Completed"
                : rowData?.status
            }
          />
        </div>

        {showActions && (
          <div className="d-flex" style={{ gap: "8px" }}>
            {props?.openMode !== "VIEW" &&
              (!isADBatch && isLecturePassed(rowData?.lectureStartTime) ? (
                <IconButtonWrapper>
                  <Tooltip title="Lecture has started. Editing is disabled.">
                    <EditIcon onClick={() => {}} />
                  </Tooltip>
                </IconButtonWrapper>
              ) : (
                <IconButtonWrapper
                  onClick={() => {
                    if (
                      !isADBatch &&
                      isLecturePassed(rowData?.lectureStartTime)
                    ) {
                      failureToast("Lecture has started. Editing is disabled.");
                      return;
                    }

                    if (isADBatch && isLecturePassed(rowData?.lectureEndTime)) {
                      failureToast("Lecture has ended. Editing is disabled.");
                      return;
                    }

                    if (
                      rowData?.classType?.toLowerCase() === "lecture" &&
                      !uuidValidateV4(rowData?.id) &&
                      rowData?.breakoutBatchId &&
                      rowData?.breakoutEventId &&
                      rowData.breakoutBatchId !== props.batchDetails.id
                    ) {
                      // published breakout lecture but not parent batch event
                      failureToast(
                        "This breakout lecture can be edited in the parent batch."
                      );

                      setTimeout(() => {
                        window.open(
                          history.createHref({
                            pathname: `/admin/testScheduling/timetable/edit/${rowData.breakoutBatchId}`,
                          }),
                          "_blank"
                        );
                      }, 2200);
                      return;
                    }

                    isAutoPopulateLectures()
                      ? setOpenWarningDialog({ open: true, action: "edit" })
                      : openRespectiveModal();
                  }}
                >
                  <EditIcon />
                </IconButtonWrapper>
              ))}

            {props?.openMode !== "VIEW" &&
              (isLecturePassed(rowData?.lectureStartTime) ? (
                <IconButtonWrapper>
                  <Tooltip title="Cannot delete as start time has passed">
                    <Delete />
                  </Tooltip>
                </IconButtonWrapper>
              ) : (
                <IconButtonWrapper
                  onClick={() => {
                    if (
                      rowData?.classType?.toLowerCase() === "lecture" &&
                      !uuidValidateV4(rowData?.id) &&
                      rowData?.breakoutBatchId &&
                      rowData?.breakoutEventId &&
                      rowData.breakoutBatchId !== props.batchDetails.id
                    ) {
                      // published breakout lecture but not parent batch event
                      failureToast(
                        "This breakout lecture cannot be deleted here."
                      );
                      return;
                    }

                    isAutoPopulateLectures()
                      ? setOpenWarningDialog({ open: true, action: "delete" })
                      : setIsDeleteDialogOpen(true);
                  }}
                >
                  <Delete />
                </IconButtonWrapper>
              ))}

            <DeleteLectureConfirmationDialog
              open={isDeleteDialogOpen}
              setOpen={setIsDeleteDialogOpen}
              data={rowData}
              onAgree={() => deleteHandler(rowIndex)}
            />
          </div>
        )}

        <div style={{ width: "80px", textAlign: "center" }}>
          {rowData?.classType?.toLowerCase() === "lecture" &&
          !uuidValidateV4(rowData?.id) &&
          rowData?.breakoutBatchId &&
          rowData?.breakoutEventId ? (
            <Tooltip title="Multi-batch lecture">
              <MultiUsers width="24" height="24" />
            </Tooltip>
          ) : (
            <span className="text-xs" style={{ color: "#ccc" }}>
              Single Batch
            </span>
          )}
        </div>
      </div>

      {expandedIndex === rowIndex && rowIndex > -1 && (
        <TestSyllabus
          testData={{ ...rowData, testScheduleId: rowData?.lectureId }}
          isTimetable={true}
          isNeedToFilterSubject={true}
        />
      )}
      <ViewDocumentModal
        setIsOpen={setViewDocumentUrl}
        isOpen={viewDocumentUrl}
      />

      <WarningPublishedDialog
        isOpen={isOpenWarningDialog.open}
        setOpenWarningDialog={(param) =>
          setOpenWarningDialog((prev) => ({ ...prev, open: param }))
        }
        rowData={rowData}
        onConfirm={() => {
          isOpenWarningDialog.action === "edit"
            ? openRespectiveModal()
            : setIsDeleteDialogOpen(true);
        }}
        onCancel={closeEditing}
      />
    </>
  );
};
